import { useEffect } from "react";

// freightpilotai.ai/mc — short link for TikTok comments. Bounces through the
// tracked share redirect so visits + signups attribute to "tiktok_comment".
export default function ShortLinkMC() {
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/share/authority-checklist?c=tiktok_comment`);
  }, []);
  return (
    <div className="min-h-screen bg-neutral-950 text-white/60 flex items-center justify-center text-sm" data-testid="short-link-mc">
      Opening the New Authority Checklist…
    </div>
  );
}
